import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { AuthTokenService } from '../services/auth-token.service';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class ApplyTokenInterceptor implements HttpInterceptor {

    constructor(private authTokenService: AuthTokenService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // get token from a service
        return this.authTokenService.getAccessToken().pipe(
            switchMap(token => {
                if(token) { // Todo: check if mcc domain
                    req = req.clone({ headers: req.headers.set('Authorization', 'Bearer ' + token) });
                }

                return next.handle(req);
            })
        );
    }
}



// WEBPACK FOOTER //
// /app/src/app/interceptors/applyTokenInterceptor.ts